import * as React from 'react'
import applyHttpsImage from 'lib/apply-https-img'

function PreloadImage(props: { urls: string[] }) {
  const { urls } = props
  return (
    <div>
      <style jsx>
        {`
          div {
            background-repeat: no-repeat;
            background-position: -9999px -9999px;
            background-image: ${urls
      .map(url => `url(${applyHttpsImage(url)})`)
      .join(',')};
          }
        `}
      </style>
    </div>
  )
}

export default React.memo(PreloadImage)
